export function spLimit(str, leftLength, rightLength) {
  let start = ''
  if (str.startsWith('-')) {
    start = '-'
    str = str.slice(1).replace(/-/g, '')
  } else {
    str = str.replace(/-/g, '')
  }
  if (str.includes('.')) {
    let [lStr, rStr] = str.split('.')
    return start + lStr.slice(0, leftLength) + '.' + rStr.slice(0, rightLength)
  } else {
    return start + str.slice(0, leftLength)
  }
}

let limit = {
  quantity(num) {
    try {
      let str = (num + '').replace(/\D/gi, '')
      return str
    } catch (e) {
      return '0'
    }
  },
  price(num) {
    return limit.amount(num, 6)
  },
  // 单价6位整数
  amount(num, leftLength = 12, minusType = false) {
    try {
      let reg = /[^\d.]/g
      if (minusType) {
        reg = /[^\d.-]/g
      }
      let str = (num + '')
        .replace(/。/g, '.') // 兼容处理，输入法输入数字时会将“。”转成“.”，但退格等其他情况不会，造成不统一。
        .replace(reg, '')
        .replace(/^\./g, '')
        .replace(/\.{2,}/g, '.')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
      return spLimit(str, leftLength, 2)
    } catch (e) {
      return '0'
    }
  },
  invoiceAmount(num, leftLength = 12, rightLength = 2) {
    try {
      let str = (num + '')
        .replace(/。/g, '.') // 兼容处理，输入法输入数字时会将“。”转成“.”，但退格等其他情况不会，造成不统一。
        .replace(/[^-?\d.]/g, '')
        .replace(/^\./g, '')
        .replace(/\.{2,}/g, '.')
        .replace('-', '$x$')
        .replace(/-/g, '')
        .replace('$x$', '-')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(-)?(\d+)\.(\d\d).*$/, '$1$2.$3')
      return spLimit(str, leftLength, rightLength)
    } catch (e) {
      return '0'
    }
  },
  invoiceAmountNew(num, leftLength = 12) {
    try {
      let str = (num + '')
        .replace(/。/g, '.') // 兼容处理，输入法输入数字时会将“。”转成“.”，但退格等其他情况不会，造成不统一。
        .replace(/[^-?\d.]/g, '')
        .replace(/^\./g, '')
        .replace(/\.{2,}/g, '.')
        .replace('-', '$x$')
        .replace(/-/g, '')
        .replace('$x$', '-')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(-)?(\d+)\.(\d\d\d\d\d\d\d).*$/, '$1$2.$3')
      return spLimit(str, leftLength, 7)
    } catch (e) {
      return '0'
    }
  },
  weight(num, leftLength = 7, rightLength = 3) {
    try {
      let str = (num + '')
        .replace(/。/g, '.') // 兼容处理，输入法输入数字时会将“。”转成“.”，但退格等其他情况不会，造成不统一。
        .replace(/[^\d.]/g, '')
        .replace(/^\./g, '')
        .replace(/\.{2,}/g, '.')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3')
      return spLimit(str, leftLength, rightLength)
    } catch (e) {
      return '0'
    }
  },
  invoiceWeight(num, leftLength = 7, rightLength = 3) {
    try {
      let str = (num + '')
        .replace(/。/g, '.') // 兼容处理，输入法输入数字时会将“。”转成“.”，但退格等其他情况不会，造成不统一。
        .replace(/[^-?\d.]/g, '')
        .replace(/^\./g, '')
        .replace(/\.{2,}/g, '.')
        .replace('-', '$x$')
        .replace(/-/g, '')
        .replace('$x$', '-')
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3')
      return spLimit(str, leftLength, rightLength)
    } catch (e) {
      return '0'
    }
  },
  account(acc) {
    try {
      let str = acc.replace(/[^-?\d.]/g, '').replace(/\./g, '')
      return str
    } catch (e) {
      return ''
    }
  },
  id(id) {
    try {
      let str = id.replace(/\D/g, '')
      return str
    } catch (e) {
      return ''
    }
  }
}

export default limit
